<template>
  <div class="Header padding">

    <div class="header">
      <router-link :to="{ name: 'Home', params: {} }">
        Textify<div class="cc">.cc</div>
      </router-link>
    </div>

    <div>
      <RoomJoin></RoomJoin>
    </div>

    <div class="right screenLarge">
      <div class="columns flex-center">
        <router-link :to="{ name: 'Features', params: {} }">
          Features
        </router-link>
        <router-link :to="{ name: 'Extension', params: {} }">
          Web extension
        </router-link>
        <BMC></BMC>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src

import RoomJoin from '@/components/RoomJoin.vue'
import BMC from '@/components/BMC.vue'

export default {
  name: 'Home',
  components: {
    RoomJoin,
    BMC
  },
  data: function () {
    return {
    }
  },
  methods: {
    showBMC: function () {
      this.$modal.show('hello-world');
    }
  },
  mounted: function () {
  }
}
</script>

<style lang="scss" scoped>

  .Header {
    background: var(--color0);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .Header > div{
    flex: 1;
  }

  .header{
    color: white;
    font-family: var(--font-header);
    font-weight: bold;
    font-size: 1.6em;
  }

  .cc{
    color: black;
    display: inline-flex;
  }

  a{
    color: white;
  }

  .columns {
    justify-content: flex-end;
  }

  .columns > *:not(:last-child){
    margin-right: 10px;
  }

</style>
